module.exports = __webpack_public_path__ + "img/diagonal-arrow-left-down.71ac4729.svg";